// extracted by mini-css-extract-plugin
export default {"input":"styles_input__hj7eC","error":"styles_error__WdWb5","white":"styles_white__uI9qS","large":"styles_large__Z0qfU"};